// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Reporting_mainContainer__e4C6m","headerTabsContainer":"Reporting_headerTabsContainer__AyZue"};